import * as Api from '@ViewModels';
import { css } from 'aphrodite';
import wealthboxLogo from '../../../../assets/logo_wealthbox_sm.svg';
import { baseStyleSheet } from '../../../../styles/styles';
import { ClioIntegrationGraphic } from '../../../svgs/graphics/ClioIntegrationGraphic';
import { IntegrationCard, useIntegrationCard } from '../IntegrationCard';
import { styleSheet, wealthboxColor } from './styles';

export const DashboardWealthboxV2IntegrationCard = () => {
	const { getLogoImgProps, getCloseButtonProps, getCtaButtonProps, getIntegrationTitleProps, showCard } =
		useIntegrationCard({
			closeIntegrationEventName: 'WealthboxV2IntegrationClosed',
			enableUrlPath: `/integrations/${Api.IntegrationProvider.Wealthbox}`,
			integrationEnableEventName: 'WealthboxV2IntegrationEnableClick',
			pendingAction: Api.PendingActions.ConnectWealthboxV2,
			checkApiPendingAction: true,
		});

	if (!showCard) {
		return null;
	}

	return (
		<IntegrationCard
			logoBgColor={wealthboxColor}
			closeButtonProps={getCloseButtonProps()}
			IntegrationGraphic={ClioIntegrationGraphic}
			headerLabel='Wealthbox Integration (V2)'
			logoImgProps={getLogoImgProps({
				alt: 'Wealthbox Logo',
				className: css(styleSheet.logo),
				src: wealthboxLogo,
			})}
			ctaButtonProps={getCtaButtonProps({
				children: 'Connect with Wealthbox V2',
				styleDeclaration: [baseStyleSheet.ctaButton, styleSheet.ctaButton],
			})}
			integrationTitleProps={getIntegrationTitleProps({
				styleDeclaration: styleSheet.integrationTitle,
			})}
		>
			<p>Enhanced Integration Available!</p>
			<p>
				We are excited to announce that you can integrate your Wealthbox account with Levitate using our new V2
				integration. With this enhanced integration, we will have the ability to pull client information, including
				names, email, phone number, birthdays, anniversaries, and more &mdash; making staying in touch even easier. We
				can also push our notes into Wealthbox with improved reliability and performance.
			</p>
		</IntegrationCard>
	);
};
